var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ModalBody, ModalFoot, ModalHead, Select, SelectItem, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { getRequestID } from 'components/shared/util/request';
import { withTemplates } from 'hocs';
import styles from './reply.module.scss';
const validate = (values) => {
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!values.auto_reply_template_id) {
        errors.auto_reply_template_id = 'Required - please select a template';
    }
    return errors;
};
class ReplyModalImpl extends Component {
    constructor(props) {
        var _a;
        super(props);
        const { node } = props;
        this.state = {
            payload: node.nodeType === FlowNodeTypes.AUTOREPLY ? node.payload : undefined,
            currentTemplateId: (_a = node.payload) === null || _a === void 0 ? void 0 : _a.auto_reply_template_id,
        };
    }
    componentDidMount() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { templates } = this.props;
            templates.getItems();
            if ((_a = this.state.payload) === null || _a === void 0 ? void 0 : _a.auto_reply_template_id) {
                const currentTemplate = yield templates.readTemplateById(this.state.payload.auto_reply_template_id);
                this.setState({ selectedTemplate: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.data });
            }
        });
    }
    handleSaveClick(values) {
        var _a, _b, _c;
        const { node, replaceNode, triggerClose } = this.props;
        const payload = {
            auto_reply_template_id: (_b = (_a = this.state.payload) === null || _a === void 0 ? void 0 : _a.auto_reply_template_id) !== null && _b !== void 0 ? _b : values.auto_reply_template_id,
            next_node_id: ((_c = node.payload) === null || _c === void 0 ? void 0 : _c.next_node_id) || getRequestID(),
        };
        const hasReplyID = typeof values.auto_reply_template_id === 'string';
        const nodeText = `Reply ${hasReplyID ? `(${values.auto_reply_template_id})` : ''}`;
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], childIds: [], icon: 'i-forward', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.AUTOREPLY, overlay: [], payload, text: nodeText });
        replaceNode(nodeOptions);
        triggerClose();
    }
    getPagination() {
        const { templates } = this.props;
        return {
            nextEnable: templates.hasNextPage,
            onNext: templates.nextPage,
            previousEnable: templates.hasPreviousPage,
            onPrevious: templates.previousPage,
        };
    }
    getTemplateOptions() {
        return this.props.templates.items;
    }
    onTemplateSearch(searchTerm) {
        const { templates } = this.props;
        if (searchTerm !== undefined && searchTerm !== templates.params.search) {
            templates.paramsChange({ search: searchTerm });
        }
    }
    onTemplateSelect(template) {
        var _a;
        const payload = {
            auto_reply_template_id: template.id,
            next_node_id: (_a = this.state.payload) === null || _a === void 0 ? void 0 : _a.next_node_id,
        };
        this.setState({
            payload,
            selectedTemplate: template,
        });
    }
    render() {
        var _a;
        const { handleSubmit, node, nodeLabel, templates: { getItemsAsyncStatus }, triggerClose, } = this.props;
        const isLoading = getItemsAsyncStatus === 'loading';
        const isChanged = ((_a = this.state.selectedTemplate) === null || _a === void 0 ? void 0 : _a.id) != this.state.currentTemplateId;
        return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: triggerClose }, { children: _jsxs("div", Object.assign({ className: styles.description }, { children: ["Send an automatic reply based on a custom template.", _jsx("br", {}), "Auto-reply templates can be created under", ' ', _jsx("strong", { children: "Settings > Templates" }), "."] })) })), _jsx(ModalBody, { children: _jsx(Select, { className: styles.dropdownContainer, itemComponent: SelectItem, items: this.getTemplateOptions(), pagination: this.getPagination(), onSearch: this.onTemplateSearch, onSelect: this.onTemplateSelect, selectedItems: this.state.selectedTemplate ? [this.state.selectedTemplate] : [] }) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: {
                        disabled: isLoading || !isChanged,
                    }, cancelOnClick: triggerClose })] })));
    }
}
__decorate([
    boundMethod
], ReplyModalImpl.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], ReplyModalImpl.prototype, "onTemplateSearch", null);
__decorate([
    boundMethod
], ReplyModalImpl.prototype, "onTemplateSelect", null);
__decorate([
    boundMethod
], ReplyModalImpl.prototype, "render", null);
const mapStateToProps = (_state, { node: { payload } }) => {
    return {
        initialValues: payload || {
            auto_reply_template_id: '',
        },
    };
};
export const ReplyModal = connect(mapStateToProps)(reduxForm({
    form: 'emailFlowReplyForm',
    enableReinitialize: true,
    validate,
})(withTemplates(ReplyModalImpl, {
    initialParams: { type: 'email_auto_reply' },
})));
